var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.search_sales}},[_c('i',{staticClass:"icon-search"}),_vm._v(" Agregar ventas ")]),_c('table-sales')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }